import cn from 'classnames';
import { Button } from '@festo-ui/react';

import './Application.scss';
import useTranslation from '../../features/translation/hooks/useTranslation';

enum TranslationKeys {
  SHOW_RESULTS = 'showResults',
}

interface ApplicationProps {
  className?: string;
  children: React.ReactNode;
  onNextClick: () => void;
  stepContainerClassName?: string;
}
export default function Application({
  className,
  children,
  onNextClick,
  stepContainerClassName,
}: ApplicationProps): JSX.Element {
  const t = useTranslation();

  return (
    <div className={cn('ems-application', className)}>
      {children}
      <div className={cn('ems-step-container', stepContainerClassName)}>
        <Button primary large onClick={onNextClick}>
          {t(TranslationKeys.SHOW_RESULTS)}
        </Button>
      </div>
    </div>
  );
}
